export interface ResolvedIcon {
  emoji: string | null;
  glyph: string | null;
}

export function resolveStoredIcon(
  icon: string | null | undefined,
  fallback = 'business-outline',
): ResolvedIcon {
  const isIoniconGlyph = typeof icon === 'string' && /^[a-z][a-z0-9-]*$/.test(icon);
  if (icon && !isIoniconGlyph) return { emoji: icon, glyph: null };
  return { emoji: null, glyph: isIoniconGlyph ? icon : fallback };
}
